<template>
  <default-view>

    <template #header>
      <span>Samples "{{ project_name }}"</span>

      <v-tooltip bottom open-delay="600ms">
        <template #activator="{ on }">
          <v-icon v-on="on" style="margin-left: 8px;">
            mdi-cog
          </v-icon>
        </template>
        <template #default>
          <pre>{{ JSON.stringify(state, null, 2) }}</pre>
        </template>
      </v-tooltip>
    </template>

    <template #toolbar-items>

      <!-- filter -->
      <v-toolbar-items style="vertical-align: middle;">
        <v-text-field
          ref="edtFilter" style="margin-top: 6px;"
          clearable dense outlined hide-details
          label="Sample filter" placeholder="regex"
          v-model="filter_field_txt"
          @keypress.enter="edtFilter_keyEnter"
          @keypress.esc="edtFilter_keyEsc"
          @click.clear="edtFilter_keyEsc">
        </v-text-field>
        <v-btn icon fer="btnFilter" @click="btnFilter_click">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <!-- add new sample -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on"
                   style="padding-right: 12px;"
                   @click="btnSampleNew_click">
              <v-badge
                color="green lighten-3 "
                light avatar bottom overlap>
                <template #default>
                  <v-icon>mdi-test-tube</v-icon>
                </template>
                <template #badge>
                  <v-icon size="20" style="margin-top: -2px;">
                    mdi-plus
                  </v-icon>
                </template>
              </v-badge>
            </v-btn>
          </template>

          <template #default>
            <span>New sample</span>
          </template>
        </v-tooltip>

      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items>

        <!-- remove checked samples -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              ref="btnDelete" icon v-on="on"
              @click="btnDelete_click"
              :disabled="sample_list_checked.length == 0">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <template #default>
            <span>Remove</span>
          </template>
        </v-tooltip>
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn v-on="on" icon @click="btnRefresh_click">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <template #default>
            <span>Refresh</span>
          </template>
        </v-tooltip>
      </v-toolbar-items>

    </template>

    <template #content>

      <div ref="divSampleList"
           v-resize="divSampleList_resize"
           style="height: 100%;">
        <!-- программно устанавливаем высоту v-data-table по div с высотой 100% -->
        <v-data-table
          ref="tblSamples"
          :height="sample_list_table_height"
          fixed-header dense disable-sort
          :headers="sample_list_headers"
          :items="sample_list_filtered"
          :items-per-page="-1"
          :hide-default-footer="true"
          item-key="id"
          show-select v-model="sample_list_checked"
          sort-by="name"
        >
          <template #item.type="{ item }">
            <!-- {{ sampleTypes[item.type_id].name }} -->
            <span v-if="item.type">
              {{ sample_types[item.type].name }}
            </span>
          </template>

          <template #item.project_selected="{ item }">
            <project-selected-menu
              v-model="item.projects"
              @save="projects_save(item.id, $event)">
            </project-selected-menu>
          </template>

          <template #item.project_text="{ item }">
            <div v-for="project_id in item.project" :key="project_id">
              {{ projects[project_id].name }}
            </div>
          </template>

          <template #item.actions="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon v-on="on"
                       @click="btnSampleEdit_click(item.id)">
                  <v-icon>mdi-file-document-edit-outline</v-icon>
                </v-btn>
              </template>
              <template #default>
                <span>Edit {{ item.id }}</span>
              </template>
            </v-tooltip>
            <v-btn icon></v-btn>
          </template>
        </v-data-table>
      </div>

      <sample-props-dialog
        ref="dlgSampleProps" :value="show_dlgSampleProps"
        :sample="sample_edit" :new="sample_new"
        @accepted="dlgSampleProps_accepted"
        @closing="dlgSampleProps_closing"
      >
      </sample-props-dialog>

    </template>

  </default-view>
</template>

<script>

	import format from 'string-format'
	import {mapActions, mapGetters} from 'vuex'

	import {Sample} from '../../models/Sample'

	import DefaultView from '../app/DefaultView'
	import SampleAddDialog from '../../components/sample/SampleAddDialog'
	import ProjectSelectedMenu from "../../components/project/ProjectSelectorMenu"
	import SamplePropsDialog from "../../components/sample/SamplePropsDialog"

	import {
		mdiTestTube, mdiPlus,
	} from '@mdi/js'

	export default {
		name: "sample-list",

		components: {
			DefaultView,
			SampleAddDialog, SamplePropsDialog,
			ProjectSelectedMenu
		},

		data: function () {
			return {
				show_filter: false,

				sample_list_table_height: 200,

				sample_list_headers: [
					{text: "", align: 'center', value: "checked",},
					{text: "Sample name", align: 'start', value: 'name',},
					{text: "Type", align: 'start', value: 'type',},
					{text: "", align: 'center', value: 'project_selected'},
					{text: "Project", align: 'start', value: 'project_text',},
					{text: "Notes", align: 'start', value: 'notes',},
					{text: "Actions", align: 'start', value: 'actions',},
				],
				sample_list_filtered: [],

				// список объектов образцов, отмеченных в таблице
				sample_list_checked: [],

				filter_field_txt: "", // значение в поле ввода

				filter: {
					name_txt: "", // значение, применяемое для фильтрации
				},

				show_dlgSampleProps: false,
				sample_edit: null,
				sample_new: false, // создать новый образец
			}
		},

		watch: {

			project_selected: function () {
				console.debug(format(
					"SampleListView.watch.project_selected( {0} )",
					this.project_selected))

				this.load_data()
			},

			'filter.name_txt': function () {
				this.update_sample_list_filtered()
			},
		},

		computed: {
			...mapGetters({
				projects: 'lists/projects',
				project_selected: 'project/selected',

				sample_types: 'lists/sampleTypes',

				sample_list: 'sample/sample_list',
				samples: 'sample/samples',
			}),

			project_name: function () {
				const selected_project = this.projects[this.project_selected]
				return selected_project ? selected_project.name : "<NONE>"
			},

			state: function () {
				return {
					sample_list_checked: this.sample_list_checked,
				}
			},
		},

		mounted: function () {
			console.debug("SampleListView.mounted()")
			this.load_data()

			// filter
		},

		methods: {
			...mapActions({
				sample_list_sample: 'sample/list_sample',
				sample_update_sample: 'sample/update_sample',
				sample_create_sample: 'sample/create_sample',
				sample_delete_samples: 'sample/delete_samples',

				message_add: 'message/add',
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
			}),

			load_data: function () {
				console.debug("SampleListView.load_data()")

				const me = this
				me.progress_begin({message: "Loading sample list ..."})
				return this.$root.$children[0].lists_promise
					.then(function () {
						console.debug("SampleListView.lost_data.lists_promise.then()")
						return me.sample_list_sample({project_id: me.project_selected})
					})
					.catch(function (error) {
						me.message_add(error)
					})
					.finally(function () {
						me.update_sample_list_filtered()
						me.divSampleList_resize()
						me.progress_end()
					})
			},

			update_sample_list_filtered: function () {
				const re = new RegExp(this.filter.name_txt, 'i')

				this.sample_list_filtered = this.sample_list
					.filter(
						function (sample) {
							return (!this.filter.name_txt || re.test(sample.name)) &&
								true
						}.bind(this))
					.sort(
						function (s1, s2) {
							return s1.name.localeCompare(s2.name)
						})

				// TODO: сохранить настройки фильтра образцов
				// this.sample_set_filter({filter: this.filter})

				console.debug("SampleListView.update_sample_list_filtered()")
			},

			create_sample: function (sample) {
				const me = this
				me.progress_begin({message: "Creating sample ..."})
				return this.sample_create_sample({sample, details: false})
					.then(function () {
						me.message_add({type: 'success', html: "Sample created."})
						return me.load_data()
					})
					.catch(function (error) {
						me.message_add(error)
						return false
					})
					.finally(function () {
						me.progress_end()
					})
			},

			update_sample: function (sample) {
				const me = this
				me.progress_begin({message: 'Update sample ...'})
				return this.sample_update_sample({sample, details: false})
					.then(function () {
						me.message_add({type: 'success', html: "Sample updated."})
						return true
					})
					.catch(function (error) {
						me.message_add(error)
						return false
					})
					.finally(function () {
						me.progress_end()
					})
			},

			delete_samples: function (sample_id_list) {
				this.progress_begin({message: "Deleting samples ..."})
				return this.sample_delete_samples(sample_id_list)
					.then(function (sample_list_deleted) {
						this.message_add({type: 'success', html: "Samples deleted."})

						this.sample_list_checked = this.sample_list_checked
							.filter((s) => sample_list_deleted.indexOf(s.id) === -1)

						return this.load_data()
					}.bind(this))
					.catch((error) => this.message_add(error))
					.finally(() => this.progress_end())
			},

			// -- Handle controls' events --

			divSampleList_resize: function (e) {
				this.sample_list_table_height =
					this.$refs.divSampleList.clientHeight
			},

			btnDelete_click: function (e) {
				this.delete_samples(this.sample_list_checked.map(s => s.id))
			},

			btnRefresh_click: function (e) {
				this.load_data()
			},

			edtFilter_keyEnter: function (e) {
				this.filter.name_txt = this.filter_field_txt
			},

			edtFilter_keyEsc: function (e) {
				this.filter.name_txt = this.filter_field_txt = ""
				this.$refs.edtFilter.focus()
			},

			btnFilter_click: function (e) {
				this.filter.name_txt = this.filter_field_txt
				this.$refs.edtFilter.focus()
			},

			projects_save: function (sample_id, projects) {
				console.debug("SampleListView.projects_save()")

				const sample = {
					id: sample_id,
					projects: projects
				}

				this.update_sample(sample)
			},

			btnSampleEdit_click: function (sample_id) {
				this.sample_new = false
				this.sample_edit = this.samples[sample_id]
				this.show_dlgSampleProps = true
			},

			btnSampleNew_click: function () {
				this.sample_new = true
				this.sample_edit = function () {
					const sample = JSON.parse(JSON.stringify(Sample.empty_sample))
					// при создании нового образца по умолчанию привязываем
					// его к текущему проекту (это можно изменить при вводе)
					sample.projects = [this.project_selected,]
					return sample
				}.bind(this)()

				this.show_dlgSampleProps = true
			},

			dlgSampleProps_accepted: function (event) {

				// объект со значениями полей
				// const sample = this.sample_edit

				if (this.sample_new) {
					event.result(this.create_sample(event.inputs))
				} else {
					event.result(this.update_sample(event.inputs))
				}
			},

			dlgSampleProps_closing: function () {
				this.show_dlgSampleProps = false
				this.sample_edit = null
				this.sample_new = false
			},
		},
	}
</script>

<style scoped>

</style>